import { inject, Injectable } from '@angular/core';
import { collection, Firestore, getDocs } from '@angular/fire/firestore';
import { createBatch, deleteBatch, OUTLINE_COLLECTION, SearchResult, updateBatch, WW_WAREHOUSES_COLLECTION } from '@damofire/data-commons';
import { WarehouseOutlineSegment } from '../warehouse/warehouse.dto';
import { generateAndAssignOutlineIds, WarehouseOutlineService } from './warehouse-outline.service';
import { AuthDtoSignerService } from '@damofire/data-security';

@Injectable()
export class FirebaseWarehouseOutlineService extends WarehouseOutlineService {
  private readonly firestore = inject(Firestore);
  private readonly signerService: AuthDtoSignerService = inject(AuthDtoSignerService);

  constructor() {
    super();
  }

  async search(divisionId: string): Promise<SearchResult<WarehouseOutlineSegment>> {
    const collectionRef = collection(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${divisionId}/${OUTLINE_COLLECTION}`);
    const snapshot = await getDocs(collectionRef);
    const items = snapshot.docs.map((doc) => ({ ...(doc.data() as WarehouseOutlineSegment), _id: doc.id }));
    return { result: items, page: { size: items.length } };
  }

  async create(divisionId: string, segments: WarehouseOutlineSegment[]): Promise<void> {
    const segmentsWithIds: WarehouseOutlineSegment[] = generateAndAssignOutlineIds(segments);

    for (const segment of segmentsWithIds) {
      await this.signerService.sign(segment, true);
    }

    return createBatch(`${WW_WAREHOUSES_COLLECTION}/${divisionId}/${OUTLINE_COLLECTION}`, segmentsWithIds);
  }

  async delete(divisionId: string, segments: WarehouseOutlineSegment[]): Promise<void> {
    return deleteBatch(`${WW_WAREHOUSES_COLLECTION}/${divisionId}/${OUTLINE_COLLECTION}`, segments);
  }

  async update(divisionId: string, segments: WarehouseOutlineSegment[]): Promise<void> {
    for (const segment of segments) {
      await this.signerService.sign(segment, false, false);
    }

    return updateBatch(`${WW_WAREHOUSES_COLLECTION}/${divisionId}/${OUTLINE_COLLECTION}`, segments);
  }
}
